export const handleChangeInputCourierVerificationPage = (name, value) => ({
    type: 'CHANGE_INPUT_COURIER_VERIFICATION_PAGE', name, value
});


export const handleChangeTimerTimeCourierVerificationPage = (timer_time) => ({
    type: 'CHANGE_TIMER_TIME_COURIER_VERIFICATION_PAGE', timer_time
});
